import React from 'react'
import { ChevronRight, Trophy } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { getTierStyle } from '../utils/achievementFormat'

const AchievementShowcase = ({ achievements, accent, primary, secondary, onAchievementClick, onOpenAll }) => {
  const { t } = useTranslation()
  if (!achievements) return null

  const showcase = Array.isArray(achievements.showcase) ? achievements.showcase : []

  return (
    <div className="relative mt-4 border-t pt-4" style={{ borderColor: `${primary}1F` }}>
      {showcase.length > 0 && (
        <div className="mb-3 grid grid-cols-3 gap-2">
          {showcase.map((achievement) => {
            const tier = getTierStyle(achievement.tier)
            return (
              <button
                key={achievement.code}
                type="button"
                onClick={() => onAchievementClick(achievement)}
                className={`block min-w-0 rounded-xl border p-2 transition-all active:scale-[0.98] ${tier.border}`}
                style={{ backgroundColor: `${primary}0D`, boxShadow: `inset 0 1px 0 rgba(255,255,255,0.06), 0 8px 22px -12px ${tier.glow}` }}
              >
                <img
                  src={achievement.image}
                  alt={achievement.name}
                  loading="lazy"
                  className="mx-auto aspect-square w-full max-w-[72px] object-contain drop-shadow-[0_8px_12px_rgba(0,0,0,0.45)]"
                />
                <span className="mt-1 block truncate text-[10px] font-bold" style={{ color: secondary }}>{achievement.name}</span>
              </button>
            )
          })}
        </div>
      )}

      <button
        type="button"
        onClick={onOpenAll}
        className="flex w-full items-center gap-2 rounded-xl border px-3 py-2.5 text-left transition-all active:scale-[0.98]"
        style={{ borderColor: `${accent}44`, backgroundColor: `${accent}10` }}
      >
        <Trophy size={16} className="shrink-0" style={{ color: accent }} />
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold" style={{ color: secondary }}>
            {t('achievements.profileCount', {
              earned: achievements.earned_count ?? 0,
              total: achievements.total_count ?? 0
            })}
          </span>
          <span className="hidden block text-[11px]" style={{ color: secondary }}>
            {t('achievements.openAll')}
          </span>
        </span>
        <ChevronRight size={17} className="shrink-0" style={{ color: accent }} />
      </button>
    </div>
  )
}

export default AchievementShowcase
